import React, { useEffect, useRef } from "react";
import styles from "./Popup.module.css";
import { cx } from "../../../Util/classHelpers";

const Popup = ({ open, onClose, children, className = "" }) => {
  const popupRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose?.();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div ref={popupRef} className={cx(styles.popup, className)}>
      {children}
    </div>
  );
};

export default Popup;
